import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmationModal } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';

const BatchDeleteVolumesModal = ({
  open,
  onClose,
  onConfirm,
  selectedVolumes = [],
  volumeItemCounts = {},
  isDeleting = false,
}) => {
  // Calculate total items count across selected volumes
  const totalItemsCount = selectedVolumes.reduce((total, volume) => {
    return total + (volumeItemCounts[volume] || 0);
  }, 0);

  return (
    <ConfirmationModal
      open={open}
      heading={
        <FormattedMessage
          id="ui-plugin-inventory-templates.batchDeleteVolumesModal.heading"
          defaultMessage="Delete Selected Volumes"
        />
      }
      message={
        <div>
          <p>
            <FormattedMessage
              id="ui-plugin-inventory-templates.batchDeleteVolumesModal.message"
              values={{
                volumeCount: selectedVolumes.length,
                itemCount: totalItemsCount,
              }}
              defaultMessage="Are you sure you want to delete {volumeCount} selected volumes containing {itemCount} items?"
            />
          </p>

          {/* List of volumes to be deleted */}
          <div style={{ marginTop: '16px', marginBottom: '16px' }}>
            <div style={{ fontWeight: '600', marginBottom: '8px' }}>
              <FormattedMessage
                id="ui-plugin-inventory-templates.batchDeleteVolumesModal.volumesList.title"
                defaultMessage="Volumes to be deleted:"
              />
            </div>
            <ul style={{ margin: 0, paddingLeft: '20px', maxHeight: '150px', overflowY: 'auto' }}>
              {selectedVolumes.map((volume) => (
                <li key={volume} style={{ marginBottom: '4px' }}>
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.batchDeleteVolumesModal.volumeItem"
                    values={{
                      volume: <strong>{volume}</strong>,
                      itemCount: volumeItemCounts[volume] || 0,
                    }}
                    defaultMessage="{volume} ({itemCount} items)"
                  />
                </li>
              ))}
            </ul>
          </div>

          <p style={{ color: '#dc3545', fontSize: '14px', marginTop: '12px' }}>
            <FormattedMessage
              id="ui-plugin-inventory-templates.batchDeleteVolumesModal.warning"
              defaultMessage="This action cannot be undone and will remove all items from the selected volumes."
            />
          </p>
        </div>
      }
      onConfirm={onConfirm}
      onCancel={onClose}
      confirmLabel={
        isDeleting ? (
          <FormattedMessage
            id="ui-plugin-inventory-templates.batchDeleteVolumesModal.deleting"
            defaultMessage="Deleting..."
          />
        ) : (
          <FormattedMessage
            id="ui-plugin-inventory-templates.batchDeleteVolumesModal.confirm"
            defaultMessage="Delete Volumes"
          />
        )
      }
      cancelLabel={
        <FormattedMessage
          id="ui-plugin-inventory-templates.batchDeleteVolumesModal.cancel"
          defaultMessage="Cancel"
        />
      }
      isConfirmButtonDisabled={isDeleting}
    />
  );
};

BatchDeleteVolumesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  selectedVolumes: PropTypes.arrayOf(PropTypes.string),
  volumeItemCounts: PropTypes.object,
  isDeleting: PropTypes.bool,
};

export default BatchDeleteVolumesModal;
